import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MembersService {
private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  featchUsers(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_users`, data);
  }

  addMembers(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/add_user`, formData);
  }

  editMembers(data: any) {
    return this.http.post(`${this.baseUrl}/edit_member`, data);
  }

  editUser(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/edit_user`, formData);
  }

  blockDropdown(data: any) {
 return this.http.post(`${this.baseUrl}/block_dropdown`, data);
}

floorDropdown(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_floor_dropdown`, data);
  }

  unitDropdown(data: any): Observable<any> {
    const payload = {
      account_id: data?.account_id != null ? String(data.account_id) : null,
      block_id: data?.block_id ?? null,
      phase_id: data?.phase_id ?? null,
      floor_id: data?.floor_id ?? null,
      unit_type: data?.unit_type ?? null,
      ...data
    };
    return this.http.post(`${this.baseUrl}/unit_dropdown`, payload);
  }

  roleDropdown(): Observable<any> {
    return this.http.get(`${this.baseUrl}/role_dropdown`);
  }

  phaseDropdown(data: any): Observable<any> {
  return this.http.post(`${this.baseUrl}/phase_dropdown`, data);
}
}
